import { cva } from 'class-variance-authority'
import type { FC } from 'react'
import { memo } from 'react'

import type { DividerProps } from './Divider.types'

const dividerCVA = cva(['border-neutral-200'], {
  variants: {
    size: {
      s: ''
    },
    vertical: {
      false: 'w-full',
      true: 'h-full'
    },
    text: {
      true: 'overflow-visible text-center after:relative after:top-[-11px] after:bg-neutral-50 after:px-2 after:text-xs after:text-neutral-600 after:content-[attr(data-description)]'
    }
  },
  compoundVariants: [
    {
      size: 's',
      vertical: false,
      class: 'border-t-1'
    },
    {
      size: 's',
      vertical: true,
      class: 'border-l-1'
    }
  ]
})

export const Divider: FC<DividerProps> = memo(
  ({ className, vertical = false, size = 's', text, ...other }) => {
    return (
      <hr
        {...other}
        className={dividerCVA({
          className,
          vertical,
          size,
          text: Boolean(text)
        })}
        data-description={text || ''}
      />
    )
  }
)

Divider.displayName = 'Divider'
export type { DividerProps } from './Divider.types'
